import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import config from 'shared/config/config';
import { Container, Divider, Message } from 'semantic-ui-react';
import messages, { FormattedMessage, withValues } from 'shared/messages/messages';
import { injectIntl } from 'react-intl';
import PurchaseDetails from './PurchaseDetails';

import {
    getAvailableMomentIds
} from 'shared/selectors/cartSelectors';

import {
    showNavBar,
} from 'shared/actions/navActions';

import {
    showStory
} from 'shared/actions/homeActions';

import {
    getPurchaseCalculations,
    getPurchases,
    unselectMoments,
    getMoments
} from 'shared/actions/cartActions';


import {
    APP_BASE_URL
} from 'shared/utils/Constants'

const styles = theme => ({
    container: {
        width: '100%',
        maxWidth: '44rem',
        display: 'block',
        margin: '5rem auto 0',
        textAlign: 'left',
        background: config.pwa_home_bg_color + " !important",
        fontFamily: config.main_font + ' !important',
        color: config.pwa_default_font_color + ' !important'
    },
    buttons: {
        float: 'left',
        marginTop: '1rem',
        paddingRight: '4rem'
    },
    button: {
        float: 'left',
        width: '100%',
        marginBottom: '1rem',
        padding: '0.3rem 1rem',
        textAlign: 'center',
        fontSize: '1rem',
        fontWeight: 600,
        background: 'linear-gradient(#ffffff, #f1f1f1)',
        border: '1px solid #dcdcdc',
        borderRadius: '3px',
        boxShadow: '0 0 2px #dcdcdc',
        color: '#2b8eb0'
    },
    messageBannerHeader: {
        color: config.pwa_default_font_color
    },
    messageBanner: {
        textAlign: 'center',
        background: config.pwa_default_bg_color + " !important",
        color: config.pwa_default_font_color + " !important",
        border: '.2em solid ' + config.pwa_default_font_color
    },
    actionContainer: {
        width: '100% !important',
        textAlign: 'center'
    },
    btnView: {
        margin: 'auto',
        textAlign: 'center',
        padding: '0.7rem 1rem',
        fontSize: '1rem',
        fontWeight: 600,
        fontFamily: config.sub_font,
        border: '1px solid ' + config.pwa_default_bg_color,
        borderRadius: '3px',
        background: config.pwa_default_button_bg_color + " !important",
        color: config.pwa_default_button_font_color + " !important"
    },
    brandContainer: {
        display: "flex",
        width: "100%",
        height: "10em"
    },
    brand: {
        marginTop: '10px',
        marginBottom: '10px',
        marginLeft: 'auto',
        marginRight: 'auto'
    }
});

class Receipt extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true
        }
    }

    componentDidMount() {
        this.loadPurchaseCalculations();
        this.loadPurchases();
    }

    renderBrand = classes => {
        return (
            <div className={classes.brandContainer}>
                <img className={classes.brand} src={this.getTopBarLogo()} />
            </div>
        )
    }

    getTopBarLogo() {
        const { user } = this.props;
        let locale = 'en-us';
        if (user) {
            locale = user.locale
        }

        if (locale && locale.includes("de")) {
            return config.pwa_navbar_desktop_brand_logo_german;
        } else {
            return config.pwa_navbar_desktop_brand_logo;
        }
    }

    handleViewPhotos = () => {
        window.location.href = APP_BASE_URL;
    }

    loadPurchaseCalculations() {
        const { availableMomentIds, openCartStoryId } = this.props;

        let maxQuantity = availableMomentIds.length;

        return this.props.getPurchaseCalculations(openCartStoryId, maxQuantity);
    }

    loadPurchases() {
        const { getPurchases, openCartStoryId } = this.props;
        getPurchases(openCartStoryId);
    }

    render() {
        const { classes, user, purchase } = this.props;

        return (
            <Container className={classes.container}>
                {this.renderBrand(classes)}
                <Divider />
                <br />
                <Message className={classes.messageBanner}>
                    <Message.Header className={classes.messageBannerHeader}><FormattedMessage {...messages.cart_thank_you_purchase} /></Message.Header>
                    <p><FormattedMessage {...withValues(messages.cart_link_to_gallery, { email: user.email })} /></p>
                </Message>
                <p></p>
                <br />
                {
                    purchase !== null &&
                    <PurchaseDetails/>
                }
                <Container className={classes.actionContainer}>
                    <button className={classes.btnView} onClick={this.handleViewPhotos.bind(this)}>
                        <FormattedMessage {...messages.cart_view_photos} />
                    </button>
                </Container>
            </Container>
        );
    }
}

const mapStateToProps = state => ({
    locale: state.userReducer.user.locale,
    user: state.userReducer.user,
    availableMomentIds: getAvailableMomentIds(state),
    selectedMomentIds: state.cartReducer.selectedMomentIds,
    openCartStoryId: state.storyReducer.openCartStoryId,
    purchases: state.cartReducer.purchases,
});

export default connect(mapStateToProps, { unselectMoments, getPurchases, getPurchaseCalculations, showStory, showNavBar, getMoments })(withStyles(styles, { withTheme: true })(injectIntl(Receipt)));
